<template>
    <v-container bg="b">
        <p class="annotation text-sm" :class="compCssClasses">
            <slot> HERE SOULD BE TEXT </slot>
        </p>
    </v-container>
</template>

<script>
import VContainer from '@/components/ui/VContainer';



export default {
    name: "VAnnotation",
    components: {
        VContainer
    },
    props: {
        mw : {
            type: [String, Number],
            default: 800
        }
    },

    computed: {
        compCssClasses(){
            return [
                `annotation_mw_${this.mw}`
            ];
        }
    }

}
</script>


<style lang="scss" scoped>
@media (max-width: 375px) {
}

@media (max-width: 411px) {
}

@media (max-width: 768px) {
}
</style>

<style scoped>


    
    .annotation{
        
        padding: 20px 0;
        text-align: center;
        margin: 0 auto;
        font-weight: 200;
        line-height: 1.5;
        color: white;

    }

    .annotation_mw_500{
        max-width: 500px;
    }
    
    .annotation_mw_800{
        max-width: 800px;
    }

</style>